import { initializeApp, getApps } from 'firebase/app'
import { getAnalytics, isSupported as analyticsSupported } from 'firebase/analytics'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
    apiKey: "AIzaSyBkXd_pNgeOObeBwD8OKrugmAj5YCcXxIA",
    authDomain: "schoolz-connect.firebaseapp.com",
    projectId: "schoolz-connect",
    storageBucket: "schoolz-connect.firebasestorage.app",
    messagingSenderId: "509672861194",
    appId: "1:509672861194:web:848df847b5b55388c039f3",
    measurementId: "G-2V9GYD69MY"
  };

// Prevent re-init during HMR
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig)

// Core services
const auth = getAuth(app)
const db = getFirestore(app)
const storage = getStorage(app)
const functions = getFunctions(app, 'us-central1')

// Analytics (browser-only, guards SSR/tests)
let analytics = null
if (typeof window !== 'undefined') {
  analyticsSupported().then((ok) => {
    if (ok) analytics = getAnalytics(app)
  })
}

export { app, auth, db, storage, functions, analytics }